import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Globals, AuthenData } from '../globals/globals';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/map';
import { OrderResponse } from '../model/criteria/order';
import { ProductResponse } from '../model/criteria/product';
import { PORequest, POResponse, DocumentResponse, DocumentLineResponse } from '../model/criteria/purchase';

@Injectable()
export class OrderService {

    private messageSource = new BehaviorSubject<any>(null);
    currentMessage = this.messageSource.asObservable();
    constructor(private http: HttpClient, private global: Globals) { }


    find(criteria): Observable<OrderResponse> {
        return this.http.post<OrderResponse>(this.global.BaseApiUrl + 'api/competency/management/find', criteria)
    }

    findProduct(criteria): Observable<ProductResponse> {
        return this.http.post<ProductResponse>(this.global.BaseApiUrl + 'api/Order/management/FindProductList', criteria)
    }

    SaveOrder(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Document/Management/SaveOrder', criteria)
    }

    EditOrder(criteria): Observable<any> {
      return this.http.post<any>(this.global.BaseApiUrl + 'api/Document/Management/EditOrder', criteria)
  }

    shipToAddress(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Order/Management/ShipToAddress', criteria)
    }
}





// WEBPACK FOOTER //
// ./src/app/services/order.services.ts